var React = require('react');

function IcAppstore (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M185.26 512c-76.2-.44-139.23-155.99-139.23-235.21 0-129.4 97.07-157.73 134.49-157.73 16.86 0 34.86 6.62 50.74 12.48 11.1 4.09 22.59 8.31 28.98 8.31 3.82 0 12.83-3.59 20.79-6.74 16.96-6.75 38.07-15.15 62.65-15.15h.15c18.35 0 74 4.03 107.46 54.27l7.84 11.78-11.28 8.51c-16.11 12.16-45.51 34.34-45.51 78.27 0 52.03 33.3 72.04 49.29 81.67 7.06 4.25 14.37 8.63 14.37 18.21 0 6.26-49.92 140.57-122.42 140.57-17.74 0-30.28-5.33-41.34-10.03-11.19-4.76-20.85-8.86-36.8-8.86-8.09 0-18.31 3.82-29.14 7.88-14.8 5.5-31.55 11.77-50.55 11.77h-.49zM351.34 0c1.89 68.08-46.8 115.3-95.43 112.34C247.9 58.01 304.54 0 351.34 0z"}));
}

IcAppstore.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = IcAppstore;

IcAppstore.default = IcAppstore;
